if (!customElements.get('collection-filters-toggle')) {
  class CollectionFiltersToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleUpdateCollectionCountRef =
        this.handleUpdateCollectionCount.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      this.classList.toggle('is-closed');

      document.dispatchEvent(
        new CustomEvent('exo:toggle-filters', {
          detail: { id: this.getAttribute('data-id') },
        }),
      );
    }

    updateHideText(event) {
      let text =
        event.detail.count == 1
          ? this.getAttribute('data-collection-text-one')
          : this.getAttribute('data-collection-text-other');

      if (!text) return;

      text = text.replace(/{{ count }}/g, event.detail.count);

      this.querySelectorAll('[data-text-target').forEach((element) => {
        element.innerText = text;
      });
    }

    updateShowText(event) {
      let text =
        event.detail.count == 1
          ? this.getAttribute('data-collection-show-text-one')
          : this.getAttribute('data-collection-show-text-other');

      if (!text) return;

      text = text.replace(/{{ count }}/g, event.detail.count);

      this.querySelectorAll('[data-show-text-target').forEach((element) => {
        element.innerText = text;
      });
    }

    handleUpdateCollectionCount(event) {
      if (!event.detail.count) return;

      this.updateHideText(event);
      this.updateShowText(event);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
      document.addEventListener(
        'exo:update-collection-count',
        this.handleUpdateCollectionCountRef,
      );
    }
  }

  customElements.define('collection-filters-toggle', CollectionFiltersToggle);
}
